import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Container,
  Tabs,
  Tab
} from '@mui/material';
import MicrosoftAuth from '../components/MicrosoftAuth';
import BasicAuth from '../components/BasicAuth';

const LoginPage: React.FC = () => {
  const [authMethod, setAuthMethod] = useState<'microsoft' | 'basic'>('microsoft');

  const handleTabChange = (event: React.SyntheticEvent, newValue: 'microsoft' | 'basic') => {
    setAuthMethod(newValue);
  };

  return (
    <Container maxWidth="sm">
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          py: 4
        }}
      >
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <Typography variant="h4" component="h1" gutterBottom>
            Abaris Container App
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 4 }}>
            Sign in to continue
          </Typography>

          
          <Tabs 
            value={authMethod} 
            onChange={handleTabChange} 
            sx={{ width: '100%', mb: 2 }}
          >
            <Tab label="Microsoft" value="microsoft" sx={{ flex: 1 }} />
            <Tab label="Staff Login" value="basic" sx={{ flex: 1 }} />
          </Tabs>
          
          {authMethod === 'microsoft' ? (
            <MicrosoftAuth />
          ) : (
            <BasicAuth />
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default LoginPage; 